module.exports = __webpack_public_path__ + "assets/monitor2.jpg?68840c6073dac9cbc601158bf08ab75d";